import React from 'react'
import { isEmpty } from 'ramda'
import { CardDrawer, CardItem } from '../../../../../../../../../../components/Card'
import Divider from '../../../../../../../../../../components/Divider'
import Buttons from '../../../../../../../../../../modules/Buttons'
import Button from '../../../../../../../../../../components/inputs/Button'
import Icon from '../../../../../../../../../../components/Icon'
import ExpansionPanel from '../../../../../../../../../../components/ExpansionPanel'
import Table from '../../../../../../../../../../components/Table'
import Modal from '../../../../../../../../../../components/Modal'
import FormRemoveBiosensor from '../../../../../Biosensors/components/FormRemoveBiosensor'
import FormAddBiosensor from '../../../../../Biosensors/components/FormAddBiosensor'
import { StyledMonitorInfo } from './styled';

function BirthMonitor({ cowid, birthMonitor, refetchCow, biosensors }) {
    return (
        <CardDrawer
            name={birthMonitor.title}
            value={birthMonitor.info ? <StyledMonitorInfo active={birthMonitor.state}>{birthMonitor.info}</StyledMonitorInfo> : '----'}
            renderOpenButton={({ handleToggleIsOpenDrawer }) => <Button noMargin onClick={handleToggleIsOpenDrawer}><Icon name='edit' /></Button>}
            renderContentDrawer={({ handleToggleIsOpenDrawer }) => (
                <Modal
                    renderOpenButton={
                        ({ handleToggleIsOpenModal }) => (
                            <Buttons>
                                <Button
                                    onClick={handleToggleIsOpenDrawer}
                                    width='50%'
                                >
                                    {birthMonitor && birthMonitor.buttons.cancel}
                                </Button>
                                <Button
                                    onClick={handleToggleIsOpenModal}
                                    green
                                    width='50%'
                                >
                                    {biosensors.tail.label}
                                </Button>
                            </Buttons>
                        )
                    }
                >
                    {
                        biosensors.tail.row_id ?
                            ({ handleToggleIsOpenModal }) => (
                                <FormRemoveBiosensor
                                    cowid={cowid}
                                    header={biosensors.tail['modal']['form-label']}
                                    biosensor={{
                                        name: 'tail',
                                        serial: biosensors.tail.row_id
                                    }}
                                    buttons={{
                                        submit: biosensors.tail['modal'].buttons.save,
                                        cancel: biosensors.tail['modal'].buttons.cancel
                                    }}
                                    onClickCancel={handleToggleIsOpenModal}
                                    refetchCow={refetchCow}
                                />
                            ) :
                            ({ handleToggleIsOpenModal }) => (
                                <>
                                    <CardItem
                                        left={{
                                            name: biosensors.tail.title,
                                            value: biosensors.tail.info
                                        }}
                                        right={<Icon name={biosensors.tail['row_id'] ? 'icon_tick' : 'icon_untick'} />}
                                    />
                                    <Divider />
                                    <FormAddBiosensor
                                        cowid={cowid}
                                        biosensor={{
                                            name: 'tail'
                                        }}
                                        endpoint={biosensors.tail['modal']['endpoint']}
                                        onClickCancel={handleToggleIsOpenModal}
                                        refetchCow={refetchCow}
                                    />
                                    <ExpansionPanel
                                        title={biosensors.tail.footer}
                                    >
                                        {
                                            !isEmpty(biosensors.tail.history.data) ?
                                                <Table
                                                    columns={[{
                                                        name: biosensors.tail.history.label.from,
                                                        key: 'from'
                                                    }, {
                                                        name: biosensors.tail.history.label.to,
                                                        key: 'to'
                                                    }, {
                                                        name: biosensors.tail.history.label.serial,
                                                        key: 'serial'
                                                    }]}
                                                    data={biosensors.tail.history.data}
                                                />
                                                :
                                                biosensors.tail.history.info
                                        }
                                    </ExpansionPanel>
                                </>
                            )
                    }
                </Modal>
            )}
        />
    )
}

export default BirthMonitor
